// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProviderProfilePage {
  background-color: #071414;
  min-height: 100vh;
}

.ProviderProfilePage .adv-page-main {
  margin-top: 17vh; /* Pushes the profile content out from under the fixed top header */
}

.provider-header-card {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 28px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  padding: 28px;
  margin-bottom: 24px;
  align-items: center;
}

@media (max-width: 768px) {
  .provider-header-card {
    grid-template-columns: 1fr;
    text-align: center;
    justify-items: center;
  }
}

.provider-profile-avatar {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.provider-profile-name {
  margin: 0 0 8px 0;
  font-size: 32px;
  font-weight: 800;
  color: #ffffff;
}

.provider-meta-row {
  display: flex;
  gap: 16px;
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .provider-meta-row {
    justify-content: center;
  }
}

.provider-meta-item {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
}

.provider-stats-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

@media (max-width: 768px) {
  .provider-stats-badges {
    justify-content: center;
  }
}

.provider-stat-badge {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 10px;
  padding: 10px 18px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 110px;
}

.provider-stat-badge .stat-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: rgba(255, 255, 255, 0.4);
}

.provider-stat-badge .stat-value {
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
}

.provider-profile-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: start;
}

@media (max-width: 1024px) {
  .provider-profile-grid {
    grid-template-columns: 1fr;
  }
}

.provider-bio-text {
  font-size: 14.5px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
  white-space: pre-line;
}

.provider-video-wrapper {
  position: relative;
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.provider-video-player {
  width: 100%;
  display: block;
}

/* Category Tabs */
.category-tabs-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding-bottom: 14px;
  margin-bottom: 20px;
}

.category-tab-btn {
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.6);
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}

.category-tab-btn:hover {
  border-color: #00f2fe;
  color: #ffffff;
}

.category-tab-btn.active {
  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);
  border-color: transparent;
  color: #0c0f13;
  font-weight: 600;
}

.no-listings-message {
  padding: 30px 10px;
  text-align: center;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  font-style: italic;
}

/* Storefront grid */
.storefront-offerings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 20px;
}

.storefront-offering-card {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s, border-color 0.2s;
}

.storefront-offering-card:hover {
  transform: translateY(-4px);
  border-color: #00f2fe;
}

.offering-card-img-container {
  position: relative;
  height: 140px;
  width: 100%;
  background: rgba(0, 0, 0, 0.2);
}

.offering-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.offering-card-badge {
  position: absolute;
  top: 8px;
  left: 8px;
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.6);
}

.offering-card-badge.service { color: #00f2fe; }
.offering-card-badge.event { color: #ffd700; }
.offering-card-badge.product { color: #28a745; }

.offering-card-info {
  padding: 14px;
}

.offering-card-title {
  margin: 0 0 8px 0;
  font-size: 14.5px;
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.offering-card-price-row {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.offering-card-price {
  font-size: 15px;
  font-weight: 700;
  color: #00f2fe;
}

.offering-card-price-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.45);
}

/* Storefront Reviews */
.storefront-reviews-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.storefront-review-card {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 16px;
}

.review-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.review-card-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.review-card-author {
  margin: 0 0 2px 0;
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
}

.review-card-date {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
}

.review-card-rating {
  margin-left: auto;
  display: flex;
  gap: 2px;
}

.review-star {
  color: #ffd700;
  font-size: 15px;
}

.review-card-text {
  font-size: 13.5px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.8);
  margin: 0 0 12px 0;
}

.review-photos-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
}

.review-photo-thumbnail {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  object-fit: cover;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.review-card-reply {
  background: rgba(90, 175, 154, 0.04);
  border-left: 3px solid #5aaf9a;
  padding: 10px 14px;
  border-radius: 0 8px 8px 0;
  margin-top: 8px;
}

.reply-header {
  margin: 0 0 4px 0;
  font-size: 12px;
  font-weight: 600;
  color: #5aaf9a;
}

.reply-text {
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.75);
  font-style: italic;
}

.animate-profile-fade-in {
  animation: profileFadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes profileFadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/ProviderProfilePage/ProviderProfilePage.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB,EAAE,mEAAmE;AACvF;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,kBAAkB;IAClB,qBAAqB;EACvB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kDAAkD;EAClD,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA,+BAA+B,cAAc,EAAE;AAC/C,6BAA6B,cAAc,EAAE;AAC7C,+BAA+B,cAAc,EAAE;;AAE/C;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".ProviderProfilePage {\n  background-color: #071414;\n  min-height: 100vh;\n}\n\n.ProviderProfilePage .adv-page-main {\n  margin-top: 17vh; /* Pushes the profile content out from under the fixed top header */\n}\n\n.provider-header-card {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 28px;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 16px;\n  padding: 28px;\n  margin-bottom: 24px;\n  align-items: center;\n}\n\n@media (max-width: 768px) {\n  .provider-header-card {\n    grid-template-columns: 1fr;\n    text-align: center;\n    justify-items: center;\n  }\n}\n\n.provider-profile-avatar {\n  width: 130px;\n  height: 130px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 3px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n}\n\n.provider-profile-name {\n  margin: 0 0 8px 0;\n  font-size: 32px;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.provider-meta-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n@media (max-width: 768px) {\n  .provider-meta-row {\n    justify-content: center;\n  }\n}\n\n.provider-meta-item {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.provider-stats-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n@media (max-width: 768px) {\n  .provider-stats-badges {\n    justify-content: center;\n  }\n}\n\n.provider-stat-badge {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 10px;\n  padding: 10px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 110px;\n}\n\n.provider-stat-badge .stat-label {\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.provider-stat-badge .stat-value {\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.provider-profile-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  align-items: start;\n}\n\n@media (max-width: 1024px) {\n  .provider-profile-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.provider-bio-text {\n  font-size: 14.5px;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.85);\n  margin: 0;\n  white-space: pre-line;\n}\n\n.provider-video-wrapper {\n  position: relative;\n  width: 100%;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.provider-video-player {\n  width: 100%;\n  display: block;\n}\n\n/* Category Tabs */\n.category-tabs-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  padding-bottom: 14px;\n  margin-bottom: 20px;\n}\n\n.category-tab-btn {\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.6);\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.category-tab-btn:hover {\n  border-color: #00f2fe;\n  color: #ffffff;\n}\n\n.category-tab-btn.active {\n  background: linear-gradient(135deg, #00f2fe 0%, #4facfe 100%);\n  border-color: transparent;\n  color: #0c0f13;\n  font-weight: 600;\n}\n\n.no-listings-message {\n  padding: 30px 10px;\n  text-align: center;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.4);\n  font-style: italic;\n}\n\n/* Storefront grid */\n.storefront-offerings-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 20px;\n}\n\n.storefront-offering-card {\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  overflow: hidden;\n  cursor: pointer;\n  transition: transform 0.2s, border-color 0.2s;\n}\n\n.storefront-offering-card:hover {\n  transform: translateY(-4px);\n  border-color: #00f2fe;\n}\n\n.offering-card-img-container {\n  position: relative;\n  height: 140px;\n  width: 100%;\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.offering-card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.offering-card-badge {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  font-size: 10px;\n  text-transform: uppercase;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.6);\n}\n\n.offering-card-badge.service { color: #00f2fe; }\n.offering-card-badge.event { color: #ffd700; }\n.offering-card-badge.product { color: #28a745; }\n\n.offering-card-info {\n  padding: 14px;\n}\n\n.offering-card-title {\n  margin: 0 0 8px 0;\n  font-size: 14.5px;\n  font-weight: 600;\n  color: #ffffff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.offering-card-price-row {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.offering-card-price {\n  font-size: 15px;\n  font-weight: 700;\n  color: #00f2fe;\n}\n\n.offering-card-price-label {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.45);\n}\n\n/* Storefront Reviews */\n.storefront-reviews-list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.storefront-review-card {\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 12px;\n  padding: 16px;\n}\n\n.review-card-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.review-card-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.review-card-author {\n  margin: 0 0 2px 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.review-card-date {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.review-card-rating {\n  margin-left: auto;\n  display: flex;\n  gap: 2px;\n}\n\n.review-star {\n  color: #ffd700;\n  font-size: 15px;\n}\n\n.review-card-text {\n  font-size: 13.5px;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.8);\n  margin: 0 0 12px 0;\n}\n\n.review-photos-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.review-photo-thumbnail {\n  width: 50px;\n  height: 50px;\n  border-radius: 6px;\n  object-fit: cover;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.review-card-reply {\n  background: rgba(90, 175, 154, 0.04);\n  border-left: 3px solid #5aaf9a;\n  padding: 10px 14px;\n  border-radius: 0 8px 8px 0;\n  margin-top: 8px;\n}\n\n.reply-header {\n  margin: 0 0 4px 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #5aaf9a;\n}\n\n.reply-text {\n  margin: 0;\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.75);\n  font-style: italic;\n}\n\n.animate-profile-fade-in {\n  animation: profileFadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n@keyframes profileFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
